export const soloProjects = [
  {
    id: 1,
    title: "SwiftCart",
    img: "https://i.ibb.co/C76R14G/SWIFTCART.png",
    description:
      "SwiftCart: The Future of E-commerce. Crafted meticulously using ReactJs and powered by Strapi, this full-stack web app offers a sleek, minimalistic design for the modern shopper. Dive into an intuitive shopping experience, where technology meets elegance.",
    technologies: "ReactJs | Redux | SCSS | Strapi",
    link: "",
    github: "https://github.com/vishaaal/swiftcraft",
  },
  {
    id: 2,
    title: "FoodFood",
    img: "https://i.ibb.co/x64gY6N/FoodFood.png",
    description:
      "FoodFood, a fullstack food delivery web application that brings a world of culinary delights. User-friendly system, where you can review your selections, modify quantities, and even remove items if your taste buds change their mind. (Still in progress)",
    technologies:
      "ReactJs | NodeJs | ExpressJS | MongoDB | Mongoose | Nodemon | Postman",
    link: "",
    github: "https://github.com/vishaaal/foodfood",
  },
  {
    id: 3,
    title: "Portfolio",
    img: "https://i.ibb.co/ynKHnLY/Portfolio-1.png",
    description:
      "This is my personal portfolio site built using ReactJS. It showcases my projects, experience, achievements, and provides a way to contact me.",
    technologies: "ReactJs | SwipperJs | EmailJs",
    link: "https://portfoliovishal.netlify.app/",
    github: "https://github.com/vishaaal/portfolio",
  },
  {
    id: 4,
    title: "Bloggerly",
    img: "https://i.ibb.co/r5KFJ1J/Bloggerly.png",
    description:
      "Personalized platform that lets creators build beautiful blogs & newsletters. Provides users with a potent, minimalist writing experience that is easy to use, well-supported, and distraction-free.",
    technologies:
      "React | React Icons | React-Router-Dom | MongoDb/ExpressJs/NodeJs (in progress)",
    link: "https://bloggerlyuem.netlify.app",
    github: "https://github.com/BlogTeam/Bloggerly",
  },
  {
    id: 5,
    title: "Ed-Venture",
    img: "https://i.ibb.co/7Szfc80/Ed-Venture.png",

    description:
      "An innovative online EdTech web-based platform (full-stack) designed to facilitate classroom development, resource sharing, and quiz administration.",
    technologies:
      "React | React Router | Vite | Tailwind | Firebase | Firestore | Netlify",
    link: "https://edventuree.netlify.app/",
    github: "https://github.com/Ed-Venture",
  },

  {
    id: 6,
    title: "TextAID",
    img: "https://i.ibb.co/3dZ7yYg/TextAID.png",

    description:
      "User friendly website to access a wide range of utility tools designed to enhance text formatting experience with a single click",
    technologies: "HTML | CSS | Vanilla JS",
    link: "https://textaid.netlify.app/",
    github: "https://github.com/vishaaal/TextAID",
  },
  {
    id: 7,
    title: "BookCase",
    img: "https://i.ibb.co/NTWfbM1/BookCase.png",
    description:
      "Open Source website, driven by the collective efforts of over 70+ passionate contributors. The platform allows other to explore the literary preferences of others and uncover hidden gems that resonate on a personal level. ",
    technologies: "HTML | CSS | Vanilla JS",
    link: "https://bookcasein.netlify.app/",
    github: "https://github.com/vishaaal/BookCase",
  },
  {
    id: 8,
    title: "CrimeAlert",
    img: "https://i.ibb.co/dBV1DjM/Crime-Alert.png",
    description:
      "A web based application to report crimes happening around and having a record of the same. The website helps in keeping track of records of criminal activities around the locality.",
    technologies: "Html/Css/Js | Bootstrap | FormSubmit.to",
    link: "https://crimealertuem.netlify.app/index.html",
    github: "https://github.com/vishaaal/CrimeAlert",
  },
];
